import { ButtonGroup, ToggleButton, Button, Form, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { pushDataLayer } from '../gtm';

export default function Step7({ formData, setFormData, prev, onSubmit, submitting }) {
  const departamentosConPresencial = ['Montevideo', 'Canelones', 'Flores'];
  const admitePresencial = departamentosConPresencial.includes(formData.departamento);
  const modalidadOpciones = admitePresencial ? ["Presencial", "Virtual", "Me da igual"] : ["Virtual"];
  const horarioOpciones = ["Matutino", "Vespertino", "Nocturno", "Me da igual"];
  const departamentosConBarrio = ['Montevideo', 'Canelones'];
  const mostrarBarrio = formData.modalidad === 'Presencial' &&
    departamentosConBarrio.includes(formData.departamento);

  const handleModalidadChange = (modalidad) => {
    const debeMantenerBarrio = modalidad === 'Presencial' &&
      departamentosConBarrio.includes(formData.departamento);

    setFormData({
      ...formData,
      modalidad,
      barrio: debeMantenerBarrio ? formData.barrio : ''
    });
  };

  const handleSubmit = () => {
    if (mostrarBarrio && !formData.barrio?.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Campo incompleto',
        text: 'Por favor, ingresá tu barrio.',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#000000'
      });
      return;
    }

    pushDataLayer('paso9_final_ok');
    onSubmit({ barrio: mostrarBarrio ? formData.barrio.trim() : '' });
  };

  return (
    <div className="form-container">
      <h2 className="form-title">¿Qué modalidad de clase preferís?</h2>
      <ButtonGroup vertical className="mb-4">
        {modalidadOpciones.map((op, idx) => (
          <ToggleButton
            key={idx}
            id={`modalidad-${idx}`}
            type="radio"
            variant="outline-primary"
            name="modalidadGroup"
            value={op}
            checked={formData.modalidad === op}
            onChange={() => handleModalidadChange(op)}
          >
            {op}
          </ToggleButton>
        ))}
      </ButtonGroup>

      {mostrarBarrio && (
        <Form.Group className="mb-4">
          <Form.Label>Barrio</Form.Label>
          <Form.Control
            type="text"
            placeholder="Ingresá tu barrio"
            value={formData.barrio}
            onChange={(e) => setFormData({ ...formData, barrio: e.target.value })}
          />
        </Form.Group>
      )}

      <h2 className="form-title">¿Qué horario preferís?</h2>
      <ButtonGroup vertical className="mb-4">
        {horarioOpciones.map((op, idx) => (
          <ToggleButton
            key={idx}
            id={`horario-${idx}`}
            type="radio"
            variant="outline-primary"
            name="horarioGroup"
            value={op}
            checked={formData.horario === op}
            onChange={() => setFormData({ ...formData, horario: op })}
          >
            {op}
          </ToggleButton>
        ))}
      </ButtonGroup>

      <div className="d-flex justify-content-between">
        <Button variant="secondary" onClick={prev} disabled={submitting}>
          Atrás
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={submitting || !modalidadOpciones.includes(formData.modalidad) || !formData.horario}
        >
          {submitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Enviando…
            </>
          ) : (
            'Enviar'
          )}
        </Button>
      </div>
    </div>
  );
}
